import { lazyLoad } from 'utils/loadable';

export const DepartmentFormPage = lazyLoad(
  () => import('./index'),
  module => module.DepartmentFormPage,
);
